"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkColor = getLinkColor;
exports.getLinkHoverColor = getLinkHoverColor;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _polished = require("polished");

var _transitions = require("./transitions");

function getLinkColor(props) {
  return props.theme.color.primaryDarkest;
}

function getLinkHoverColor(props) {
  return (0, _polished.opacify)(-0.2, getLinkColor(props));
}

var Link = (0, _styledComponents.css)(["", " color:", ";cursor:pointer;font-size:16px;line-height:20px;text-decoration:none;transition-property:color;.icon-inherit-color{fill:", ";}&:hover{color:", ";.icon-inherit-color{fill:", ";}}"], _transitions.switchTransition, getLinkColor, getLinkColor, getLinkHoverColor, getLinkHoverColor);
var _default = Link;
exports["default"] = _default;